// One thing a customer can add to their account.
//
// The library is the same list for everybody; what differs is where each item stands for this
// customer — their plan may include it, they may have bought it, they may be able to buy it, or
// their plan may not offer it at all.
export default interface AddonCatalog {
    key?: string
    name?: string
    tagline?: string
    description?: string

    icon?: any
    iconType?: any
    image?: string

    price: number
    priceText?: string

    state: AddonState
    stateText?: string
    note?: string

    features?: string[]

    /** Matches AddonTypes on the server when it can be bought. */
    addonType?: number
    canPurchase?: boolean

    /** Bought by the number (extra users): asks how many, and stays on sale after the first. */
    byQuantity?: boolean
    maxQuantity?: number
    /** How many the account holds now, across every purchase. */
    quantity?: number
    /** Each live purchase, soonest renewal first. Each renews on its own, so each is its own tile. */
    purchases?: AddonPurchase[]

    /** The add-on row behind it, when the account holds one. */
    addonId?: string
    purchasedAt?: string
    renewedAt?: string
    /** When it renews next -- or, once cancelled, when it ends. */
    expiresAt?: string
    isCanceled?: boolean
    /** Never for what the plan includes: that comes and goes with the plan. */
    canCancel?: boolean

    /** It belongs on the wall: included with the plan, or bought. */
    isOnWall?: boolean
}


/** One purchase of an add-on that can be bought more than once. */
export interface AddonPurchase {
    id?: string
    count: number
    name?: string
    priceText?: string
    expiresAt?: string
    note?: string
    purchasedAt?: string
    renewedAt?: string
    isCanceled?: boolean
    /** A smaller number asked for from the next period; until then it keeps `count`. */
    nextCount?: number
    canCancel?: boolean
}


export enum AddonState {
    Included = 1,
    Active = 2,
    Available = 3,
    NotOffered = 4,
    /** In the catalog, but with no way to buy it yet. */
    ComingSoon = 5
}
